import { SR_API_ACTION_UTILITY_ACTIVATION_ITEM_GET_BULK_BILLING } from 'api/utilityActionTypes';

export default function getItemBulkBilling({ state, utilityApiClient }, { itemId, onError }) {
  return utilityApiClient.postWithState({
    action: SR_API_ACTION_UTILITY_ACTIVATION_ITEM_GET_BULK_BILLING,
    state: state,
    queryId: itemId,
    payload: { itemId },
    onError,
  });
}
